import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/.well-known/openid-configuration")(
  serverRouteConfig({
    server: {
      handlers: {
        GET: async ({ request }) => {
          const { handleShortLinksOidcDiscovery } = await import(
            "@api/features/short-links-sso/shortLinksOidcHandlers"
          )
          return handleShortLinksOidcDiscovery(request)
        },
      },
    },
  })
)
